import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TagContainer } from '../models/container';
import { Event } from '../models/event';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  private functions: Map<TagContainer, string> = new Map([
    [TagContainer.Media, 'tc_events_1'],
    [TagContainer.Analytics, 'tc_events_7'],
    [TagContainer.ABtests, 'tc_events_12']
  ]);
  private defaultContainer = TagContainer.Analytics;
  private verbose = environment.analytics.verbose;
  private isBrowser: boolean;
  private containerLoad = true;
  private firstCall = true;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);

    if (this.isBrowser) {
      this.functions.forEach(fn => {
        if (typeof window[fn] !== 'function') {
          this.containerLoad = false;
        }
      });
    }
  }

  send(...events: Event[]): void {
    if (!this.isBrowser && !this.containerLoad) {
      return;
    }
    events.forEach(event => {
      if (event.type !== 'containerCall' || !this.firstCall) {
        const containerId = event.container || this.defaultContainer;
        const functionName = this.functions.get(containerId);
        setTimeout(() => {
          if (this.verbose) {
            console.log(`[Tracking] Send "${event.type}" event`, event);
          }

          if (typeof window[functionName] === 'function') {
            window[functionName](this, event.type, event.payload || {});
          }
        }, event.timeout || 0);
      } else if (event.type === 'containerCall' && this.firstCall) {
        this.firstCall = false;
      }
    });
  }
}
